export enum CONFIG_PARAMS {
  GAME_DATA_API_KEY = 'game-data-api-key',
  GAME_DATA_SERVICE_URL = 'gds-url',
  PLAYER_DATA_API_KEY = 'player-data-api-key',
  PLAYER_DATA_SERVICE_URL = 'pds-url',
  CLIENT_ID = 'client-id',
  ENTRY = 'entry',
  HOST_NAME = 'host-name',
  PLAYER_ID = 'player-id',
  RAPID_GAME_ID = 'rapid-game-id',
}
